import { render, staticRenderFns } from "./SelectTrainingPlans.vue?vue&type=template&id=282169f4&"
import script from "./SelectTrainingPlans.vue?vue&type=script&lang=js&"
export * from "./SelectTrainingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports